<template>
    <div class="sheetLogs">
        <div
            v-show="showBack"
            class="sheetLogs-back"
            @click="backToAll"
        >返回</div>
        <div class="sheetLogs-content">
            <Timeline v-if="dataList.length">
                <TimelineItem
                    v-for="logItem in dataList"
                    :key="logItem._id"
                    color="blue"
                >
                    <p
                        :style="{
                            cursor: (type=='all' && showBack==false) ? 'pointer' : ''
                        }"
                        @click="showDetailLogs(logItem.oid)"
                    >
                        <img
                            :src="$imageResize(logItem.user && logItem.user.avatarurl || $imageSrcMap.system.boy, {m: 'lfit',  w: 18, h: 18})"
                            class="sheetLogs-content-avatar"
                        >
                        <span
                            v-if="logItem.user"
                            class="sheetLogs-content-user"
                        >{{ logItem.user.realname || logItem.user.username || logItem.user.mobile }}</span>
                        <span
                            v-else
                            class="sheetLogs-content-user"
                        >匿名用户</span>
                        <span class="sheetLogs-content-time">{{ $transformDate(logItem.updatedAt) }}</span>
                        <span class="sheetLogs-content-acton">{{ actions[logItem.action].name }}了记录</span>
                        <span v-if="type=='all'&&logItem.dataName">({{logItem.dataName}})</span>
                    </p>
                    <p>
                    <p
                        class="changed"
                        v-for="(changeItem, changeIndex) in logItem.changed"
                        :key="changeIndex"
                    >
                        {{ changeItem }}
                    </p>
                    </p>
                </TimelineItem>
            </Timeline>
            <p
                v-else
                class="sheetLogs-content-noData"
            >暂无记录</p>
        </div>
        <div class="sheetLogs-footer">
            <Page
                :total="total"
                :page-size="pagesize"
                size="small"
                @on-change="pageChange"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "sheetLogs",
        inject: ["companyId", "appId"],
        props: {
            dataId: String,
            modKey: String,
            type: {
                type: String,
                default: "single",
                validator: function (val) {
                    return ["single", "all"].includes(val);
                }
            },
            urlParams: {
                type: Object,
                default: () => {
                    return {
                        module: "sheet",
                        name: "customLog"
                    };
                }

            },
            params: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {
                dataList: [],
                showBack: false,
                actions: {
                    create: {
                        key: "create",
                        name: "创建"
                    },
                    update: {
                        key: "update",
                        name: "更新"
                    },
                    delete: {
                        key: "delete",
                        name: "删除"
                    }
                },
                total: 0,
                pagesize: 20,
                page: 1
            };
        },
        created () {
            this.init();
        },
        methods: {
            init () {
                this.getData();
            },
            getData (id) {
                let _id = id || this.dataId;
                this.$https({
                    url: {
                        params: {
                            modKey: this.modKey
                        },
                        ...this.urlParams
                    },
                    params: {
                        _id,
                        pagination: {
                            page: this.page,
                            pagesize: this.pagesize
                        },
                        ...this.params
                    },
                    callback: data => {
                        this.total = data.total;
                        this.dataList = data.list;
                    }
                });
            },
            pageChange (page) {
                this.page = page;
                this.getData();
            },
            // 外层工作表全部记录点击单条
            showDetailLogs (_id) {
                if (this.showBack == true || this.type !== "all") return;
                this.getData(_id);
                this.showBack = true;
            },
            backToAll () {
                this.dataId = undefined;
                this.showBack = false;
                this.getData();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/attach/sheetLogs.vue